import styled from 'styled-components';
import { BUTTON_VARIANTS, Dialog } from 'cdk-radial';

export const StyledDialog = styled(Dialog)`
  min-width: 560px;
  max-width: 30%;
  margin-top: 60px;
  z-index: 9999;
  height: auto;
  max-height: 400px;
  @media (max-width: 470px) {
    min-width: 10vw;
    max-width: 100%;
    width: 92vw;
    top: 310px;
  }
  @media (max-width: 570px) {
    min-width: 10vw;
    max-width: 100%;
    width: 92vw;
  }
`;

export const StyledDialogContent = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  min-height: 50px;
  max-height: 250px
  padding: 0px 10px
  @media (max-width: 470px) {
    padding-left: 0px;
  }
`;

const UnifyRestrictionDialog = (props: {
  message:string;
  isOpen: boolean;
  onClose: Function;
}): JSX.Element => {
  return (
    <div>
      <StyledDialog
        buttonsProps={[
          {
            id: 'restriction-dialog-close',
            onClick: props.onClose,
            text: 'Close',
            variant: BUTTON_VARIANTS.PRIMARY,
          },
        ]}
        id="restriction-dialog"
        isOpen={props.isOpen}
        onClose={props.onClose}
        title="CDK Unify"
      >
        <StyledDialogContent>
          {props.message}
        </StyledDialogContent>
      </StyledDialog>
    </div>
  );
};
export default UnifyRestrictionDialog;
